import React from "react";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import "./App.css";
import Home from "./Route/Home";
import Login from "./Route/Login";
import Sso from "./Route/Sso";
import Developer from "./Route/Developer";

function App() {
  return (
    <div className="App" style={{ height: "100%" }}>
      <BrowserRouter>
        <Routes>
          <Route path="/" exact element={<Login />} />
          <Route path="/home" exact element={<Home />} />
          <Route path="/sso" exact element={<Sso />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
